import { render, staticRenderFns } from "./TagChip.vue?vue&type=template&id=e95ea50e&scoped=true&"
import script from "./TagChip.vue?vue&type=script&lang=ts&"
export * from "./TagChip.vue?vue&type=script&lang=ts&"
import style0 from "./TagChip.vue?vue&type=style&index=0&id=e95ea50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95ea50e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
